import { IGaEvent } from 'base/utils/tracker-ga';
import { getParamInSearch } from 'ava-util/dist/request';
import { DEBUG_TRACKER } from 'base/config/constant';
import { IStartTrackDataFull } from 'mod/track/interface';

declare const window: any;

let isStarted = false; //是否开始发送数据
let todoFunctions: Function[] = []; //等待执行的回调

/**
 * 发送数据
 * @param eventName console中的提示文案
 * @param data 要发送的数据
 */
function track(eventName: string, data: Record<string, any> | (() => Record<string, any>)) {
    if (eventName !== 'config') {
        if (typeof data === 'function') {
            data = data();
        }
        const { event_id, ...rest } = data as Record<string, any>;
        data = {
            event: eventName,
            eventId: event_id,
            eventData: rest,
        };
    }

    if (getParamInSearch(DEBUG_TRACKER) === '1') {
        console.log(`----- GTM: ${eventName} -----`);
        console.log(data);
    }
    if (window.gtmDataLayer) {
        window.gtmDataLayer.push({ eventData: undefined, });
        window.gtmDataLayer.push(data);
    }
}

/**
 * 运行 todoFunctions 中保存你的等待执行的回调函数
 */
function runCallbacks(): void {
    // 执行待执行的回调
    if (todoFunctions.length) {
        todoFunctions.map(callback => callback());
        todoFunctions = [];
    }
}

/**
 * 发送数据前验证是否符合发送条件，不符合条件的暂时保存在 todoFunctions 数组中
 * @param eventName console中的提示文案
 * @param data 要发送的数据
 */
function trackOrDelay(eventName: string, data: Record<string, any>) {
    // 主动触发 start 之前，放到数组中等待执行
    if (isStarted) {
        track(eventName, data);
    } else {
        todoFunctions.push(function() {
            track(eventName, data);
        });
    }
}


export function gtmEvent(eventName: string, data: IGaEvent | (() => IGaEvent)) {
    trackOrDelay(eventName, data);
}

export function gtmStartTrack(data: IStartTrackDataFull) {
    const {
        userId,
        email,
        sha1Email,
        lang,
        country,
        currency,
        userTags,
    } = data;

    track('config', {
        config: {
            userId,
            userData: {
                email_address: email,
                sha1_email: sha1Email
            },
            user_tags: userTags,
            env: process.env.NEXT_PUBLIC_ENV_NAME || 'prod',
            selected_language: lang,
            country,
            currency,
        }
    })
    if (!isStarted) {
        isStarted = true;
        runCallbacks();
    }
}
